<template>
  <div>
    <home-page>
      <router-view></router-view>
    </home-page>
  </div>
</template>

<script>
import homePage from '@p/components/homePage'
export default {
  data(){
    return {

    }
  },
  components:{
    homePage,
  },
}
</script>


<style>

</style>
